import React from 'react';

const Vimeo = (props) => (
  <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M22.3532 8.50141C22.3532 6.01663 20.7417 4 18.7521 4C17.3195 4 15.9456 4.5691 14.9325 5.58212C13.9195 6.59513 13.3504 7.96907 13.3504 9.40169H14.7008C18.2299 9.40169 13.8816 15.7037 12.9003 15.7037C10.7666 15.7037 11.1537 4 8.39887 4C7.27352 4 4.74373 5.74655 1.64676 10.302L3.44732 11.2023L5.24789 9.40169C5.24789 9.40169 6.82338 22.9059 11.0997 22.9059C15.3761 22.9059 22.3532 13.3449 22.3532 8.50141Z"
      stroke="#3F3C43"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
  </svg>
);

export default Vimeo;
